import { array, object, string, TypeOf } from 'zod'
import * as z from 'zod'

export enum ShareType {
  GROUP = 'group',
  MEMBERS = 'members',
}

export const shareTypeOptions = [
  { label: 'Entire Group', value: ShareType.GROUP },
  { label: 'Specific Members', value: ShareType.MEMBERS },
]

export const MAX_COMMENTS_LENGTH = 50

export const shareFormSchema = object({
  type: string(),
  members: array(
    object({
      label: string(),
      value: string(),
    }),
  ),
  comments: z
    .string()
    .max(MAX_COMMENTS_LENGTH, `Max message length is ${MAX_COMMENTS_LENGTH} characters`)
    .optional(),
})

export type ShareFormValues = TypeOf<typeof shareFormSchema>

export type ShareMemberOption = {
  label: string
  value: string
}
